export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7761.605c9f88.jpg";